import { render, staticRenderFns } from "./SelloImportExcel.vue?vue&type=template&id=29c5f677"
import script from "./SelloImportExcel.vue?vue&type=script&lang=js"
export * from "./SelloImportExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports